import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "customValidationErrors", "defaultReview", "headerContent", "onChange", "onClose", "onSubmit", "showLegalCheckbox", "validationSchema"];
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Link } from 'foundations-components/transitional/components/Link';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { ScreenReaderAnnouncer } from 'marketplace-ui-common/components/accessibility/ScreenReaderAnnouncer';
import { Fragment, useCallback, useState } from 'react';
import { ReviewContextProvider, useReviewContext } from './context/ReviewContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ReviewModal(_ref) {
  let {
      children,
      customValidationErrors = [],
      defaultReview = {
        content: {},
        ratings: {},
        tags: {}
      },
      headerContent,
      onChange,
      onClose,
      onSubmit,
      showLegalCheckbox = false,
      validationSchema
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ReviewContextProvider, {
    customValidationErrors: customValidationErrors,
    defaultReview: defaultReview,
    onChange: onChange,
    validationSchema: validationSchema,
    children: /*#__PURE__*/_jsxs(Modal, Object.assign({}, rest, {
      onEsc: onClose,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [headerContent, /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        paddingBlockStart: "0",
        children: children
      }), /*#__PURE__*/_jsx(DialogFooter, {
        align: "left",
        paddingBlockStart: "200",
        children: /*#__PURE__*/_jsx(FooterContent, {
          onClose: onClose,
          onSubmit: onSubmit,
          showLegalCheckbox: showLegalCheckbox
        })
      })]
    }))
  });
}
function FooterContent({
  onClose,
  onSubmit,
  showLegalCheckbox
}) {
  const {
    customValidationErrors,
    review,
    validationErrors
  } = useReviewContext();
  const [checkedLegalDisclaimer, setCheckedLegalDisclaimer] = useState(false);
  const [showLegalTooltip, setShowLegalTooltip] = useState(false);
  const handleSubmitClick = useCallback(() => {
    if (showLegalCheckbox && !checkedLegalDisclaimer) {
      setShowLegalTooltip(true);
    } else {
      onSubmit(review);
    }
  }, [checkedLegalDisclaimer, onSubmit, review, showLegalCheckbox]);
  const isDisabled = validationErrors.length > 0 || customValidationErrors.length > 0;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [showLegalCheckbox && /*#__PURE__*/_jsx(ScreenReaderAnnouncer, {
      announcedText: showLegalTooltip ? unescapedText('trellisEcosystem.reviews.legalTooltip') : '',
      use: "assertive"
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "500",
      children: [showLegalCheckbox && /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "row",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          open: showLegalTooltip,
          title: unescapedText('trellisEcosystem.reviews.legalTooltip'),
          children: /*#__PURE__*/_jsx(Checkbox, {
            "aria-labelledby": "disclaimer-text",
            checked: checkedLegalDisclaimer,
            onChange: ({
              target: {
                checked
              }
            }) => {
              setShowLegalTooltip(false);
              setCheckedLegalDisclaimer(checked);
            }
          })
        }), /*#__PURE__*/_jsx(View, {
          id: "disclaimer-text",
          marginInlineStart: "200",
          as: "span",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            elements: {
              Link
            },
            message: "trellisEcosystem.reviews.legal_jsx",
            options: {
              external: true,
              href: 'https://legal.hubspot.com/review-guidelines'
            }
          })
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        gap: "300",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: customValidationErrors[0],
          children: /*#__PURE__*/_jsx(Button, {
            disabled: isDisabled,
            onClick: handleSubmitClick,
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "trellisEcosystem.reviews.submit"
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "trellisEcosystem.reviews.cancel"
          })
        })]
      })]
    })]
  });
}